

.interaction
{
  background-color: white;
  border-radius: var(--border-radius);
  padding: 15px 25px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  position: relative;



  .message {

  }

  .photos {
    img {
      max-width: 300px;
      max-height: 300px;
    }
  }

  .row {
    flex-direction: column;
    display: flex;


    .titleRow {

      flex-direction: row;
      display: flex;
      gap: .5em;
      align-items: center;

      .date {
        color: var(--beigedark);
        font-size: 11pt;
      }

      .rowTitle {
        flex-grow: 1;
      }
    }



    .spreadRow {
      flex-direction: row;
      display: flex;
      gap: .5em;
      margin-top: 0.5em;

      align-items: start;
      justify-content: space-between;
      color: var(--beigedarker);
      * {
        font-size: 11pt;
      }

      .heartButton{
        display: inline-block;
        padding: 0 0.5em;
      }
    }

  }
}


.reply {
  flex-direction: column !important;
  padding: 1em;
  border-radius: 26px;
  margin: 0 0 10px 0;
  background-color: var(--beigelight);
  position: relative;

  .titleRow {

    flex-direction: row;
    display: flex;
    gap: .5em;
    align-items: center;


    .name {
      color: var(--beigedarker);
      margin-bottom: 0.5em;
      flex-grow: 1;
    }
  }



  .date {
    margin-top: 0.5em;
    font-style: italic;
    color: var(--beigedarker);
    font-size: 11pt;
  }
}
.replyForm
{
  display: flex;
  gap: 10px;

  .input {
    border-radius: 20px;
    background-color: var(--beigelight);
    border: 0;
    padding: 10px 20px;
    flex-grow: 1;
  }
  .sendButton
  {
    border-radius: 20px;
    width: 40px;
    height: 40px;
    padding: 0;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }

}



.youtubeContainer {
  position: relative;
  overflow: hidden;
  width: 100%;

  &::after {
    display: block;
    content: "";
    padding-top: 56.25%;
  }

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.statusRefused
{
  background-color: #c8c6c2;
}

.statusExamine::after
{
  position: absolute;
  content: ' ';
  width: 100%;
  height: 100%;
  z-index: 100;
  top: 0;
  left: 0;
  opacity: 0.2;
  background: black;

  border-radius: var(--border-radius);
}

.examineOverlay {

  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 110;
  top: 0;
  left: 0;

}